import QueryJoinExample from "../../../../contents/docs/data-warehouse/_snippets/query-join-example.mdx";
import * as React from 'react';
export default {
  QueryJoinExample,
  React
};